export default "__VITE_ASSET__BBtGuDR2__"